var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGuardActivating = function SvgGuardActivating(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3935-4",
    fill: "currentColor",
    d: "M14.36 1027.4a2.363 2.363 0 0 0-2.36 2.374v11.25a2.364 2.364 0 0 0 2.36 2.376H29.2a5.65 5.688 0 0 1-5.65-5.688 5.65 5.688 0 0 1 5.65-5.687 5.65 5.688 0 0 1 2.67.677v-2.927a2.363 2.363 0 0 0-2.36-2.375zm14.84 15.999h.31c.19 0 .372-.028.55-.07a5.65 5.688 0 0 1-.86.07m-7.265-11a1.994 1.994 0 0 1 .993 3.72v2.78h-1.986v-2.78a1.994 1.994 0 0 1 .993-3.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3939-8",
    fill: "currentColor",
    d: "M21.936 1017.4c-3.84 0-6.954 2.686-6.954 6v3h2.98v-1.969c0-2.233 1.78-4.031 3.974-4.031s3.974 1.799 3.974 4.031v1.969h2.98v-3c0-3.314-3.113-6-6.954-6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle4520",
    cx: 29.2,
    cy: 1037.7,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 4.238,
    ry: 4.266
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4524",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M29.2 1035.2v2.438l-1.436 1.435"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGuardActivating);
export default ForwardRef;